import React from 'react';
import Layout from '../components/Layout';

const Unauthorized = () => (
  <Layout>
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '70vh' }}>
    <h1 style={{ fontSize: '5rem', color: '#f39c12' }}>403</h1>
    <h2>Unauthorized</h2>
    <p>You do not have permission to access this page.</p>
  </div>
  </Layout>
);

export default Unauthorized;
